import axios from 'axios'

const inventoryServices = {
  getProductsInventoryItems: ({ storeId, params }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/inventory-items`, {
      params,
      paramsSerializer: { indexes: null },
    })
  },
  editItemInfo: ({ storeId, itemId, payload }) =>
    axios.patch(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-items/${itemId}`, payload),
  getInventoryMetrics: ({ storeId, filters }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/metrics/inventory-items-summary`, {
      params: { store_id: storeId, time_range: 'year', ...filters },
      paramsSerializer: { indexes: null },
    })
  },
  startAutoFix: ({ storeId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-items/auto-fix-proposal`, payload),
  inventoryItemsBulkUpdate: ({ storeId, payload }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-items/bulk-update`, payload),
  exportInventoryItems: ({ storeId, params, filters }) => {
    return axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/products/inventory-items/export`, params, {
      params: filters,
      paramsSerializer: { indexes: null },
    })
  },
  importInventoryItems: ({ storeId, formData }) =>
    axios.post(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-imports`, formData),
  getInventoryImport: ({ storeId, reportId }) =>
    axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-imports/${reportId}`),
  getCustomsRequirements: ({ storeId }) => {
    return axios.get(`${import.meta.env.VITE_HOST}/stores/${storeId}/inventory-items/customs-requirements`)
  },
}

export default inventoryServices
